import { useMemo } from 'react'
import { bindActionCreators } from 'redux'

const useActions = (dispatch, ...actionSets) => {
  return useMemo(() => {
    const actions = {}
    actionSets.forEach(actionSet => {
      Object.assign(actions, bindActionCreators(actionSet.actions, dispatch))
    })
    return actions
  }, [dispatch])
}

export default useActions